var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-center-frame"},[_c('div',{staticClass:"mo-comingsoon"},[_c('p',[_vm._v("COMING SOON")])])])}]

export { render, staticRenderFns }